import { UseFormReturn } from 'react-hook-form';
import { MiscellaneousField } from '../../reportsTypes';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  InfoIconTooltip,
  Input,
} from '@ais-ui/ui-core';

interface NumberItemProps {
  fieldName: string;
  form: UseFormReturn;
  fieldInfo: MiscellaneousField;
}

export const MiscellaneousNumberItem = ({
  fieldName,
  form,
  fieldInfo,
}: NumberItemProps) => {
  return (
    <FormField
      key={fieldName}
      control={form.control}
      name={fieldName}
      render={({ field }) => (
        <FormItem>
          <div className="flex justify-between">
            <FormLabel>
              {fieldInfo.name}: {fieldInfo.required && '*'}
            </FormLabel>
            {fieldInfo.help && (
              <InfoIconTooltip className="mr-2">
                {fieldInfo.help}
              </InfoIconTooltip>
            )}
          </div>
          <FormControl onChange={() => form.clearErrors()}>
            <Input
              type="number"
              placeholder={fieldInfo.placeholder}
              {...field}
              onChange={(e) => {
                if (!e.target.value) {
                  field.onChange('');
                } else {
                  const numberValue = parseFloat(e.target.value);
                  field.onChange(numberValue);
                }
              }}
            />
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
};
